export const GENERAL_PHONE_NUMBER = '866-306-1988';
export const COLORADO_PHONE_NUMBER = '720-255-1683';
export const CALIFORNIA_PHONE_NUMBER = '720-251-4499';
export const SAN_DIEGO_PHONE_NUMBER = '858-215-2592';
export const ORANGE_COUNTY_PHONE_NUMBER = '714-202-6394';
export const PHOENIX_PHONE_NUMBER = '602-351-5872';
